import { useSolarConfigurationStore } from "@stores/solar-configuration-store.ts";

export const useHasSolar = () => {
  const hasSolar = useSolarConfigurationStore((state) => state.hasSolar);
  return hasSolar === "Yes";
};
